import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import ContactInfoForm from "../Layout/ContactInfoForm";

import { ContactInfoFormValues } from "src/models/ContactInfo.model";
import {
  useGetCMSByTypeQuery,
  useUpdateCMSMutation,
} from "src/services/CMSService";

type Props = {
  onClose: () => void;
};

const EditContactInfoWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});
  const {
    data,
    isLoading,
    isFetching,
  }: // refetch,
  any = useGetCMSByTypeQuery("CONTACT_INFO");
  const [updateContactById] = useUpdateCMSMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: ContactInfoFormValues = {
    content: items?.length
      ? items.map((item: any) => ({
          address: item?.address || "",
          phoneNumber: Array.isArray(item?.phoneNumber)
            ? item?.phoneNumber
            : item?.phoneNumber
            ? [item?.phoneNumber]
            : [""],
        }))
      : [
          {
            address: "",
            phoneNumber: [""],
          },
        ],
  };

  // Validation Schema
  const validationSchema = Yup.object().shape({
    content: Yup.array().of(
      Yup.object().shape({
        address: Yup.string().required("Please enter address"),
        phoneNumber: Yup.array()
          .of(
            Yup.string()
              .required("Please enter phone number")
              .matches(/^[0-9+\-\s]+$/, "Invalid phone number")
          )
          .min(1, "At least one phone number is required"),
      })
    ),
  });

  // Handle Submit
  const handleSubmit = (
    values: ContactInfoFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ContactInfoFormValues>
  ) => {
    const payload = {
      content: values.content.map((c) => ({
        address: c.address,
        phoneNumber:
          c.phoneNumber.length === 1 ? c.phoneNumber[0] : c.phoneNumber,
      })),
    };

    updateContactById({ type: "CONTACT_INFO", body: payload })
      .unwrap()
      .then((res) => {
        showToast("success", res?.data?.message);
        onClose();
        // refetch()
        setSubmitting(false);
        resetForm();
      })
      .catch((err) => {
        console.error("Failed to update Contact Info: ", err);
        showToast(
          "error",
          err?.data?.message ||
            "Failed to update Contact Info. Please try again."
        );
        setSubmitting(false);
      });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ContactInfoForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditContactInfoWrapper;
